import { useMemo } from 'react'
import useConfig from 'modules/config/state/use-config'
import useFlow from 'modules/flow/state/use-flow'
import SocialPanel from 'modules/social-panel/social-panel'
import { RightPanelType } from 'modules/flow/state/utils/steps/constants'
import ContentPanel from 'modules/ui/organisms/ContentPanel'

// Map enum values to components
const componentMap = {
  [RightPanelType.SocialPanel]: SocialPanel,
}

export const useRightPanelComponent = () => {
  const flow = useFlow()
  const config = useConfig()
  const rightPanelType = flow.currentStep.rightPanel

  return useMemo(() => {
    if (rightPanelType) {
      return componentMap[rightPanelType]
    }

    return config.contentPanel ? ContentPanel : null
  }, [rightPanelType, config.contentPanel])
}
